import ReactComponent from '../app/ReactComponent'
import {Flex} from 'antd'

export default class WhoWeArePage extends ReactComponent {
  render() {
    return (
      <section className="fullwidth">
        <Flex align="center" justify="center" style={{height: '100%', minHeight: '90vh'}}>
          <div className="container ta-center">
            <h2>Cooming soon.</h2>
          </div>
        </Flex>
      </section>
    )
  }
}